export const normalizeDomain = (domain: string): string => domain.trim().toLowerCase();

/*
 * Normalizes every domain and drops empties and duplicates, preserving first-seen order.
 * Used both when loading existing config and when adding a new one, so the two paths stay
 * consistent with the BE (which dedupes case-insensitively after lowercasing).
 */
export const normalizeWarmupDomains = (domains: string[]): string[] => {
    const seen = new Set<string>();
    const result: string[] = [];

    for (const domain of domains) {
        const normalized = normalizeDomain(domain);

        if (normalized && !seen.has(normalized)) {
            seen.add(normalized);
            result.push(normalized);
        }
    }

    return result;
};

/*
 * Re-points every warm-up domain at `senderDomain` by keeping its subdomain prefix
 * (everything before the last two labels) and swapping in the new sender domain. Keeps
 * chips in sync when the Email Sender Domain changes. Empties/duplicates are dropped.
 */
export const replaceWarmupSuffix = (domains: string[], senderDomain: string): string[] => {
    const sender = normalizeDomain(senderDomain);

    const remapped = domains.map(domain => {
        const prefix = normalizeDomain(domain).split('.').slice(0, -2).join('.');

        return prefix ? `${prefix}.${sender}` : '';
    });

    return normalizeWarmupDomains(remapped);
};
